/* global $:false */

import { DEV_MODE } from './cob.devmode.js';
import doT from 'dot';

// # Cob.Templator
//
// Deals with compiling and applying templates. Uses [doT](https://github.com/olado/doT)
var Templator = function() {
    var _compiledTemplates = {};

    return {
        compileAll: function(html){
            $(html).filter('script[type="text/x-doT-tmpl"]').each(function(idx, tmpl) {
                try {
                    DEV_MODE && window.console.log("TMPL:compiling template " + tmpl.id);

                    _compiledTemplates[tmpl.id] = doT.template(tmpl.text);

                } catch (err) {
                    window.console.log("TMPL:ERROR: " + err);
                }
            });
        },

        compile: function(name, templateTxt) {
            _compiledTemplates[name] = doT.template(templateTxt);
           return _compiledTemplates[name];
        },

        apply: function(name, data) {
            //we do this so that we can see which template has problems
            if (typeof _compiledTemplates[name] !== 'function') {
                window.console.log('TMPL:ERROR: Template "' + name + '" not found.');
            }
            //we trim() because jQuery doesn't like to $(html) strings that don't start with "<"
            return _compiledTemplates[name](data).trim();
        }
    };
};

export default Templator;
